import { Component, Input } from '@angular/core';

@Component({
    selector: 'fi-business-unit-locked-information',
    templateUrl: './business-unit-locked-information.component.html',
    styleUrls: ['./business-unit-locked-information.component.scss'],
    standalone: false,
})
export class BusinessUnitLockedInformationComponent {
    @Input() businessUnit: any;

    constructor() {}
}
